import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

/* ── Icons ── */
const IconEye = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#bceb39" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);
const IconMap = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#bceb39" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
    <line x1="9" y1="3" x2="9" y2="18"/>
    <line x1="15" y1="6" x2="15" y2="21"/>
  </svg>
);
const IconZap = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#bceb39" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);
const IconSmile = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#bceb39" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
    <line x1="9" y1="9" x2="9.01" y2="9"/>
    <line x1="15" y1="9" x2="15.01" y2="9"/>
  </svg>
);

/* ── Step Icons removed — How It Works section removed ── */

const AdvertisementPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />

      {/* ── HERO ── */}
      <section className="pt-32 pb-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">

            {/* Left text */}
            <div className="space-y-8">
              <div className="inline-block bg-[#bceb39]/10 border border-[#bceb39]/30 text-[#bceb39] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full">
                Advertise with Nura
              </div>
              <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight">
                Grow Your{' '}
                <span className="inline-block bg-[#bceb39] text-black px-3 py-1 rounded-lg">Brand</span>{' '}
                with Nura
              </h1>
              <p className="text-gray-400 text-xl leading-relaxed">
                Turn every ride into a moving billboard. Reach thousands of daily
                commuters across Chennai with high-visibility ads on Nura's electric
                auto fleet.
              </p>
              <a
                href="https://wa.me/message/FLHEAG6HCYGCH1"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#bceb39] text-black font-bold px-8 py-4 rounded-full text-lg hover:bg-[#a8d632] hover:scale-105 transition-all duration-200"
              >
                Advertise With Us &rarr;
              </a>
            </div>

          </div>
        </div>
      </section>

      {/* ── VALUE PROPS ── */}
      <section className="py-20 bg-black border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Why Advertise on Nura?
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Chennai's streets are always moving. Make sure your brand moves with them.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: <IconEye />, title: 'Mass Daily Reach', desc: 'Thousands of daily commuters across Chennai see your brand on every trip.' },
              { icon: <IconMap />, title: 'Hyperlocal Targeting', desc: 'Geo-targeted exposure in the neighbourhoods that matter most to your business.' },
              { icon: <IconZap />, title: 'High-Visibility Panels', desc: 'Rear and interior ad panels on our electric auto fleet, impossible to miss.' },
              { icon: <IconSmile />, title: 'Hassle-Free Onboarding', desc: 'Simple process from inquiry to go-live. We handle the logistics so you do not have to.' },
            ].map((item) => (
              <div key={item.title} className="bg-white/5 border border-white/10 rounded-2xl p-7 hover:border-[#bceb39] transition-colors group">
                <div className="mb-5">{item.icon}</div>
                <h3 className="text-white font-bold text-lg mb-3 group-hover:text-[#bceb39] transition-colors">{item.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── BOTTOM CTA ── */}
      <section className="py-20 bg-black border-t border-white/5">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#bceb39] rounded-3xl p-12 text-center">
            <h2 className="text-black text-3xl md:text-4xl font-bold mb-4 leading-tight">
              Ready to put your brand on Chennai's streets?
            </h2>
            <p className="text-black/70 text-lg mb-8 max-w-xl mx-auto">
              Reach out on WhatsApp and let's talk about what works best for your brand.
              No pricing listed here. Every campaign is tailored to your goals.
            </p>
            <a
              href="https://wa.me/message/FLHEAG6HCYGCH1"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-black text-[#bceb39] font-bold px-10 py-4 rounded-full text-lg hover:scale-105 transition-transform"
            >
              Get in Touch on WhatsApp &rarr;
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AdvertisementPage;
